<template>
  <div style="height:100%;padding: 14px 20px;box-sizing: border-box;">
    <h2 align="center" style="color:green;">加班审核表</h2>
    <el-row>
      <div class="block" width="50%" style="display:inline-block;float:left">
        <data-time @datachange="timechange"></data-time>
        <div style="display:inline-block">
          <el-button size="small" @click="allpass" type="primary" v-if="timeFlag=='open'">全部通过</el-button>
        </div>
      </div>
      <div style="display:inline-block;float:right">
        <el-button @click="exportToExcel" size="small" type="success">导出表格</el-button>
        <el-button size="small" @click="gotohome" type="primary">《《 返回首页</el-button>
      </div>
    </el-row>
    <get-table ref="diaoyong" :CtableData.sync="tableData" @getdata="getstage" style="height:80%;" :CtimeFlag.sync="timeFlag"></get-table>
  </div>
</template>
<script>
import DataTime from "@/base/DataTime";
import GetTable from "./GetTable";
import axios from "axios";
import { showLoading, hideLoading } from "@/lib/loading";
import {
  hourToMin,
  getTaskOptionValue,
  backHome,
  myGrounpX,
  gettaskOptions,
  gettasklistStrName,
  exptime
} from "@/lib/until";
export default {
  name: "person",
  components: {
    DataTime,
    GetTable
  },
  data() {
    return {
      nowtime: "",
      personId: "",
      tableData: [],
      base_info: [],
      timeFlag:""
    };
  },
  created() {
    this.getuserInfo();
  },
  methods: {
    getstage(jieduan, baseInfo) {
      this.getDatajieduan = jieduan;
      this.base_info = baseInfo;
      //console.log(opt);
      //console.log(baseInfo);
    },
    getuserInfo() {
      var uesrInfo = JSON.parse(localStorage.getItem("uesrInfo"));
      this.depart_id = uesrInfo.depart_ID;
      this.personId = uesrInfo.employee_id;
      this.password = uesrInfo.password;
      //console.log(this.depart_id);
    },
    timechange(time) {
      exptime(time).then(res => {
        this.timeFlag = res;
      });
      axios
        .get(IPConfig.IP + "/kpi-management/info/overtime_report_info.php", {
          params: {
            overtime_report_date: time,
            //params: { encodeout: "utf-8" }

          }
        })
        .then(data => {
          showLoading();
          //console.log(data.data);
          if (data.data.errcode == 0) {
            this.tableData = [];
            var searchMsg = data.data;

            var valueList = Object.values(searchMsg.overtime_report_list).sort(
              function(a, b) {
                return a.employee_id - b.employee_id;
              }
            );
            this.search(valueList);
          } else {
            this.tableData = [];
          }
        })
        .catch(error => {
          //console.log(error);
          hideLoading();
        });
    },
    search(getDailyMsg) {
      if (typeof getDailyMsg == "undefined" || getDailyMsg.length <= 0) {
        hideLoading();
        return;
      }
      //console.log(getDailyMsg);
      var tableList = [];
      for (var i = 0; i < getDailyMsg.length; i++) {
        let vms = getDailyMsg[i];
        //获取部门名字
        for (let key in this.base_info.depart_list) {
          if (vms.depart_id == key) {
            vms["bumencn"] = this.base_info.depart_list[key].depart_name;
          }
        }
        //获取阶段名字
        for (let key in this.base_info.project_list) {
          if (vms.project_id == key) {
            vms["xiangmucn"] = this.base_info.project_list[key].project_name_cn;
          }
        }
        //获取人员
        for (let key in this.base_info.employee_all_list) {
          //console.log(key);
          if (vms.employee_id == key) {
            vms["rycn"] = this.base_info.employee_all_list[key].employee_name;
          }
        }
        let chioseList = gettaskOptions(vms.depart_id, this.base_info);
        vms["chioes"] = chioseList;
        //console.log(vms)

        vms["value1"] = getTaskOptionValue(vms.task_id, chioseList);
        var taskoptions = this.base_info.depart_all_task_list[vms.depart_id];
        var scopeName = [];
        Object.assign(scopeName, vms["value1"]);
        if (scopeName.length > 0) {
          vms["task_name_str"] = gettasklistStrName(
            vms.task_id,
            scopeName,
            taskoptions
          );
        }

        hourToMin(vms);
        tableList.push(vms);
        this.tableData = Object.values(tableList).sort(function(a, b) {
          return a.employee_id - b.employee_id;
        });
        // this.tableData.push(vms);
      }
      myGrounpX(this.tableData);
      hideLoading();
      //console.log(this.tableData);
    },
    gotohome() {
      backHome(this);
    },
    exportToExcel() {
      this.$refs.diaoyong.exportToExcel();
    },
    gbbumenId(value) {
      this.$refs.diaoyong.gbbumenId(value);
    },
    allpass() {
      this.$refs.diaoyong.allpass();
    }
  }
};
</script>
<style>
.titleBumen {
  width: 134px !important;
  margin-left: 20px !important;
  color: red !important;
}
</style>




// WEBPACK FOOTER //
// src/views/Examine/index.vue